import dayjs from "dayjs";

const dateFormatFunc = (date) => {
    return date.replace('T', ' ').substring(0, 19);
}

const dateSetSecondWithT = (date) => {
    if(!date) return;
    if(date.length > 16) {
        return date;
    }
    return dayjs(date).format("YYYY-MM-DDTHH:mm:00");
}

const getKeyByValue = (obj, value) => {
    return Object.keys(obj).find(key => obj[key]=== value)}

const commonFunc = {
    dateFormatFunc,
    getKeyByValue,
    dateSetSecondWithT
}

export default commonFunc